'use strict';

var d3 = require('d3');
var HorizontalAverageLines = function HorizontalAverageLines(d3Helper, tooltip) {
  return function (aggregatePropertyName, tooltipContentProvider) {
    var params, scales, tooltipInitialized, tip;
    var horizontalAverageLines = function horizontalAverageLines(container) {
      var bandPadding,
        rectHeight = 3,
        rectWidth = 0,
        averages = [];
      var tooltipAdded = tooltipContentProvider !== undefined;
      if (tooltipAdded && !tooltipInitialized) {
        tip = tooltip(tooltipContentProvider, tooltipContentProvider.cssClass);
      }
      var group = container.select('.groups').selectAll('.stack.visible');
      container.selectAll('g.average-line-group').remove();
      var addAverageLine = function addAverageLine(selection) {
        selection.each(function (d) {
          var avgLineSelection = d3.select(this);
          avgLineSelection.attr({
            'class': 'average-line-group',
            'transform': d.transform
          });
          avgLineSelection.append('rect').attr('class', 'average-line');
          avgLineSelection.selectAll('rect').attr({
            'y': scales.yScale(d.average),
            'x': -d.rectWidth + d.bandPadding + scales.xScale.rangeBand(),
            'width': d.rectWidth - d.bandPadding,
            'height': d.rectHeight
          });
        });
        selection.call(bindEvents);
      };
      var mouseOverHandler = function mouseOverHandler(d) {
        var tooltipDirection = typeof d.tooltipDirection === 'string' ? d.tooltipDirection : 'n';
        var offsetX = 5;
        var offsetY = tooltipDirection === 'n' ? -17 : 17;
        tip.offset([offsetY, offsetX]);
        tip.direction(tooltipDirection);
        tip.show(d, this);
        d3Helper.adjustTooltipTopPosition();
      };
      var mouseOutHandler = function mouseOutHandler() {
        tip.hideAndAdjustPosition();
      };
      function bindEvents(selection) {
        if (tooltipAdded) {
          selection.on('mouseout', mouseOutHandler);
          selection.on('mouseover', mouseOverHandler);
        }
      }
      function unbindEvents(selection) {
        if (tooltipAdded) {
          selection.on('mouseout', null);
          selection.on('mouseover', null);
        }
      }
      bandPadding = (scales.xScale.rangeExtent()[1] - scales.xScale.rangeBand() * group[0].length) / group[0].length;
      group.each(function (d, i) {
        if (d[aggregatePropertyName] === undefined) {
          return;
        }
        var drawAverageLine = false;
        rectWidth += scales.xScale.rangeBand() + bandPadding;
        if (!group.data()[i + 1]) {
          drawAverageLine = true;
        } else if (group.data()[i][aggregatePropertyName] !== group.data()[i + 1][aggregatePropertyName]) {
          drawAverageLine = true;
        }
        if (drawAverageLine) {
          averages.push({
            season: d.season,
            average: d.average,
            rectWidth: rectWidth,
            rectHeight: rectHeight,
            bandPadding: bandPadding,
            transform: d3.select(this).attr('transform')
          });
          rectWidth = 0;
        }
      });
      var averageGroup = container.selectAll('.average-line-group').data(averages);
      averageGroup.enter().append('g').call(addAverageLine);
      averageGroup.exit().select('g').call(unbindEvents);
      if (!tooltipInitialized && tooltipAdded) {
        container.call(tip);
        tooltipInitialized = true;
      }
    };
    horizontalAverageLines.params = function (value) {
      params = value;
      return horizontalAverageLines;
    };
    horizontalAverageLines.scales = function (value) {
      scales = value;
      return horizontalAverageLines;
    };
    return horizontalAverageLines;
  };
};
HorizontalAverageLines.$inject = ['d3Helper', 'ChartElementsTooltip'];
module.exports = HorizontalAverageLines;